/**
 * NO SORTING, NO PAGINATION,
 * ONLY FIXED HEADER
 */
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';

const padding = 10;
const dark = '#333333';
const styles = {
    // tableWrapper: {
    //      height: '100%',
    // },
    section: {
        position: 'relative',
        paddingTop: 36,
        background: dark,
        // height: '86%',
        //boxShadow: '0 1px 3px 1px #777777',
    },
    tableScroll: {
        //height: '100%',
        overflowY: 'auto',
        background: '#fff',
        height: '100%',
    },
    table: {
        margin: 0,
        paddingBottom: 10,
        fontFamily: 'arial',
        borderCollapse: 'collapse',
        width: '100%',
        border: '1px solid #333',
        '& td': {
            fontSize: 13,
            padding: padding,
            border: '1px solid #cccccc',
        },
        '& td:first-child': {
            background: '#dadada',
        },
    },
    thead: {
        '& th': {
            // fontSize: 14,
            height: 0,
            lineHeight: 0,
            paddingTop: 0,
            paddingBottom: 0,
            color: 'transparent',
            border: 'none',
            whiteSpace: 'nowrap',
        },
        '& th:first-child': {
            width: 8,
            // borderLeft: 'none'
        },
    },
    pseudoTh: {
        fontSize: 14,
        fontWeight: 500,
        position: 'absolute',
        background: 'transparent',
        color: '#fff',
        padding: 10,
        top: 0,
        lineHeight: 'normal',
        borderLeft: '1px solid #ccc',
    },
    '@media print': {
        pseudoTh: {
            display: 'none',
        },
        section: {
         paddingTop: 0
        },
        thead: {
            '& th': {
                lineHeight: 'normal',
                color: '#000',
                padding: 12,
                border: '1px solid #000',
                textAlign: 'left',
            },
        },
        table: {
            width: '99%',
            '& td': {
                border: '1px solid #000',
            },
        },
    },
};

class TableSimple extends React.Component {
    showFixedHeader = () => {
        let h = document.getElementById('fixed-table-header').tHead;

        document.getElementById('showFix').innerHTML = h.innerHTML;
    };

    render() {
        const { header, data, classes } = this.props;

        return (
            /* <div className={classes.tableWrapper}> */
                <section className={classes.section}>
                    <div className={classes.tableScroll}>
                        <table className={classes.table} id="fixed-header">
                            <thead className={classes.thead}>
                                <tr>
                                    <th>
                                        #
                                        <div
                                            className={classes.pseudoTh}
                                            style={{
                                                borderLeft: 'none',
                                                cursor: 'auto',
                                            }}
                                        >
                                            #
                                        </div>
                                    </th>
                                    {header.map((h, ind) => (
                                        <th key={ind}>
                                            {h.label}
                                            <div className={classes.pseudoTh}>
                                                {h.label}
                                            </div>
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((f, ind) => (
                                    <tr key={ind}>
                                        <td>{ind + 1}</td>
                                        {header.map((h, ind2) => (
                                            <td key={ind2}>{f[h.key]}</td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </section>
            /* </div> */
        );
    }
}

TableSimple.propTypes = {
    header: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
    paginate: PropTypes.bool,
    caption: PropTypes.string,
};

export default withStyles(styles)(TableSimple);

/**
 * HEADER OBJECT FORMAT
 * {
 * id: unique identifier for operation (not shown in table values)
 * label: string, (display label )
 * type: integer ( determines whether to sort by string method or number method), 1 for string, 2 for number
 * }
 */
